/* eslint-disable jsx-a11y/heading-has-content */
import PropTypes from 'prop-types';
import React from 'react';
import styled, { css } from 'styled-components';

const H1 = styled.h1`
  ${(props) => (props.type === 'aside' && css`
    font-size: 24px;
    color: #fdce00;
    cursor: default;
  `)}

  ${(props) => props.type === 'tool' && css`
    font-size: 24px;
    color: #fdce00;
    cursor: default;
    grid-column: span 2;
  `}

  ${(props) => props.type === 'resource' && css`
    font-size: 80px;
    font-weight: 800;
    letter-spacing: -1px;
    color: #5493fc;
  `}
`;

export const Heading = (props) => {
  switch (props.level) {
    case 1:
      return <H1 type={props.type}>{props.children}</H1>;
    case 2:
      return <h2>{props.children}</h2>;
    case 3:
      return <h3>{props.children}</h3>;
    case 4:
      return <h4>{props.children}</h4>;
    case 5:
      return <h5>{props.children}</h5>;
    case 6:
      return <h6>{props.children}</h6>;
    default:
      break;
  }
};

Heading.propTypes = {
  level : PropTypes.number.isRequired,
  children : PropTypes.any,
  type : PropTypes.string
};

Heading.defaultProps = {
  level : 1,
  children : 'Heading1',
  type : 'aside'
};  